export default (sourceString, searchString) => sourceString.toLowerCase().indexOf(searchString) > -1;
